window.keyboard = function (clicked_id) {
    var clickedKeyID = clicked_id.replace('key-', '');

    var led = document.querySelectorAll('#ledBoard ul li');
    var key = document.querySelector('#keyBoard');
    var output = document.querySelector('#output');

    var rotor1Input = document.querySelector('#rotor-1').value;
    var ring1Input = document.querySelector('#ring-1').value;

    var ring2Input = document.querySelector('#ring-2').value;
    var rotor2Input = document.querySelector('#rotor-2').value;

    var ring3Input = document.querySelector('#ring-3').value;
    var rotor3Input = document.querySelector('#rotor-3').value;

    var plugboard = document.querySelectorAll('#pairs input');
    var keyID = '';

    // Plugboard Input
    plugboard.forEach(pb => {
        var pbName = pb.name.replace('checkbox-key-', '');
        var pbValue = pb.value.replace('checkbox-key-', '');

        if (pbName == clickedKeyID) {
            keyID = pbValue;
        }
        else if (pbValue == clickedKeyID) {
            keyID = pbName;
        }

    });


    if (keyID == '') {
        keyID = clickedKeyID;
    }

    //
    //
    //
    // rotor 1

    rotor1();

    function rotor1() {


        // 1
        if (rotor1Input == 1) {

            if (keyID == 'A') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }

        }

        // 2
        else if (rotor1Input == 2) {

            if (keyID == 'A') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }

        }

        // 3
        else if (rotor1Input == 3) {

            if (keyID == 'A') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }

        }

        // 4
        else if (rotor1Input == 4) {

            if (keyID == 'A') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }

        }

        // 5
        else if (rotor1Input == 5) {

            if (keyID == 'A') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }

        }

        // 6
        else if (rotor1Input == 6) {

            if (keyID == 'A') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }

        }

        // 7
        else if (rotor1Input == 7) {

            if (keyID == 'A') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }

        }

        // 8
        else if (rotor1Input == 8) {

            if (keyID == 'A') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }

        }

        // 9
        else if (rotor1Input == 9) {

            if (keyID == 'A') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }

        }

        // 10
        else if (rotor1Input == 10) {

            if (keyID == 'A') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }

        }

        // 11
        else if (rotor1Input == 11) {

            if (keyID == 'A') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }

        }

        // 12
        else if (rotor1Input == 12) {

            if (keyID == 'A') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }

        }

        // 13
        else if (rotor1Input == 13) {

            if (keyID == 'A') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }

        }

        // 14
        else if (rotor1Input == 14) {

            if (keyID == 'A') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }

        }

        // 15
        else if (rotor1Input == 15) {

            if (keyID == 'A') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }

        }

        // 16
        else if (rotor1Input == 16) {

            if (keyID == 'A') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }

        }

        // 17
        else if (rotor1Input == 17) {

            if (keyID == 'A') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }

        }

        // 18
        else if (rotor1Input == 18) {

            if (keyID == 'A') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }

        }

        // 19
        else if (rotor1Input == 19) {

            if (keyID == 'A') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }

        }

        // 20
        else if (rotor1Input == 20) {

            if (keyID == 'A') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }

        }

        // 21
        else if (rotor1Input == 21) {

            if (keyID == 'A') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }

        }

        // 22
        else if (rotor1Input == 22) {

            if (keyID == 'A') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }

        }

        // 23
        else if (rotor1Input == 23) {

            if (keyID == 'A') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }

        }

        // 24
        else if (rotor1Input == 24) {

            if (keyID == 'A') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }

        }

        // 25
        else if (rotor1Input == 25) {

            if (keyID == 'A') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }

        }

        // 26
        else if (rotor1Input == 26) {

            if (keyID == 'A') {
                keyIDRotor1 = 'D';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'B') {
                keyIDRotor1 = 'P';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'C') {
                keyIDRotor1 = 'W';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'D') {
                keyIDRotor1 = 'A';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'E') {
                keyIDRotor1 = 'Z';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'F') {
                keyIDRotor1 = 'L';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'G') {
                keyIDRotor1 = 'K';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'H') {
                keyIDRotor1 = 'S';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'I') {
                keyIDRotor1 = 'J';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'J') {
                keyIDRotor1 = 'I';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'K') {
                keyIDRotor1 = 'G';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'L') {
                keyIDRotor1 = 'F';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'M') {
                keyIDRotor1 = 'X';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'N') {
                keyIDRotor1 = 'T';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'O') {
                keyIDRotor1 = 'R';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'P') {
                keyIDRotor1 = 'B';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Q') {
                keyIDRotor1 = 'Y';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'R') {
                keyIDRotor1 = 'O';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'S') {
                keyIDRotor1 = 'H';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'T') {
                keyIDRotor1 = 'N';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'U') {
                keyIDRotor1 = 'V';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'V') {
                keyIDRotor1 = 'U';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'W') {
                keyIDRotor1 = 'C';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'X') {
                keyIDRotor1 = 'M';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Y') {
                keyIDRotor1 = 'Q';
                rotor2(keyIDRotor1);
            }
            else if (keyID == 'Z') {
                keyIDRotor1 = 'E';
                rotor2(keyIDRotor1);
            }

        }

    }



    //
    //
    //
    // rotor 2



    function rotor2() {


        // 4
        if (rotor2Input == 4) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }

        }

        // 8
        else if (rotor2Input == 8) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }

        }

        // 7
        else if (rotor2Input == 7) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }

        }

        // 1
        else if (rotor2Input == 1) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }

        }

        // 20
        else if (rotor2Input == 20) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }

        }

        // 26
        else if (rotor2Input == 26) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }

        }

        // 3
        else if (rotor2Input == 3) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }

        }

        // 2
        else if (rotor2Input == 2) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }

        }

        // 10
        else if (rotor2Input == 10) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }

        }

        // 9
        else if (rotor2Input == 9) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }

        }

        // 14
        else if (rotor2Input == 14) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }

        }

        // 15
        else if (rotor2Input == 15) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }

        }

        // 24
        else if (rotor2Input == 24) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }

        }

        // 11
        else if (rotor2Input == 11) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }

        }

        // 12
        else if (rotor2Input == 12) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }

        }

        // 16
        else if (rotor2Input == 16) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }

        }

        // 18
        else if (rotor2Input == 18) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }

        }

        // 17
        else if (rotor2Input == 17) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }

        }

        // 19
        else if (rotor2Input == 19) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }

        }

        // 5
        else if (rotor2Input == 5) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }

        }

        // 22
        else if (rotor2Input == 22) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }

        }

        // 21
        else if (rotor2Input == 21) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }

        }

        // 25
        else if (rotor2Input == 25) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }

        }

        // 13
        else if (rotor2Input == 13) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }

        }

        // 23
        else if (rotor2Input == 23) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }

        }

        // 6
        else if (rotor2Input == 6) {

            if (keyIDRotor1 == 'A') {
                keyIDRotor2 = 'D';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'B') {
                keyIDRotor2 = 'P';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'C') {
                keyIDRotor2 = 'W';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'D') {
                keyIDRotor2 = 'A';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'E') {
                keyIDRotor2 = 'Z';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'F') {
                keyIDRotor2 = 'L';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'G') {
                keyIDRotor2 = 'K';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'H') {
                keyIDRotor2 = 'S';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'I') {
                keyIDRotor2 = 'J';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'J') {
                keyIDRotor2 = 'I';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'K') {
                keyIDRotor2 = 'G';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'L') {
                keyIDRotor2 = 'F';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'M') {
                keyIDRotor2 = 'X';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'N') {
                keyIDRotor2 = 'T';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'O') {
                keyIDRotor2 = 'R';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'P') {
                keyIDRotor2 = 'B';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Q') {
                keyIDRotor2 = 'Y';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'R') {
                keyIDRotor2 = 'O';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'S') {
                keyIDRotor2 = 'H';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'T') {
                keyIDRotor2 = 'N';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'U') {
                keyIDRotor2 = 'V';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'V') {
                keyIDRotor2 = 'U';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'W') {
                keyIDRotor2 = 'C';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'X') {
                keyIDRotor2 = 'M';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Y') {
                keyIDRotor2 = 'Q';
                rotor3(keyIDRotor2);
            }
            else if (keyIDRotor1 == 'Z') {
                keyIDRotor2 = 'E';
                rotor3(keyIDRotor2);
            }
        }

    }


//
//
//
//
//
    //
    //
    //
    // Rotor 3



    function rotor3() {


        // 5
        if (rotor3Input == 5) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }

        }

        // 6
        else if (rotor3Input == 6) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }

        }

        // 13
        else if (rotor3Input == 13) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }

        }

        // 4
        else if (rotor3Input == 4) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }

        }

        // 1
        else if (rotor3Input == 1) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }

        }

        // 2
        else if (rotor3Input == 2) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }

        }

        // 20
        else if (rotor3Input == 20) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }

        }

        // 8
        else if (rotor3Input == 8) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }

        }

        // 9
        else if (rotor3Input == 9) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }

        }

        // 26
        else if (rotor3Input == 26) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }

        }

        // 11
        else if (rotor3Input == 11) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }

        }

        // 12
        else if (rotor3Input == 12) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }

        }

        // 3
        else if (rotor3Input == 3) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }

        }

        // 14
        else if (rotor3Input == 14) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }

        }

        // 15
        else if (rotor3Input == 15) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }

        }

        // 16
        else if (rotor3Input == 16) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }

        }

        // 17
        else if (rotor3Input == 17) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }

        }

        // 18
        else if (rotor3Input == 18) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }

        }

        // 19
        else if (rotor3Input == 19) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }

        }

        // 7
        else if (rotor3Input == 7) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }

        }

        // 21
        else if (rotor3Input == 21) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }

        }

        // 22
        else if (rotor3Input == 22) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }

        }

        // 23
        else if (rotor3Input == 23) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }

        }

        // 24
        else if (rotor3Input == 24) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }

        }

        // 25
        else if (rotor3Input == 25) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }

        }

        // 10
        else if (rotor3Input == 10) {

            if (keyIDRotor2 == 'A') {
                keyIDRotor3 = 'D';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'B') {
                keyIDRotor3 = 'P';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'C') {
                keyIDRotor3 = 'W';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'D') {
                keyIDRotor3 = 'A';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'E') {
                keyIDRotor3 = 'Z';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'F') {
                keyIDRotor3 = 'L';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'G') {
                keyIDRotor3 = 'K';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'H') {
                keyIDRotor3 = 'S';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'I') {
                keyIDRotor3 = 'J';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'J') {
                keyIDRotor3 = 'I';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'K') {
                keyIDRotor3 = 'G';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'L') {
                keyIDRotor3 = 'F';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'M') {
                keyIDRotor3 = 'X';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'N') {
                keyIDRotor3 = 'T';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'O') {
                keyIDRotor3 = 'R';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'P') {
                keyIDRotor3 = 'B';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Q') {
                keyIDRotor3 = 'Y';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'R') {
                keyIDRotor3 = 'O';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'S') {
                keyIDRotor3 = 'H';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'T') {
                keyIDRotor3 = 'N';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'U') {
                keyIDRotor3 = 'V';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'V') {
                keyIDRotor3 = 'U';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'W') {
                keyIDRotor3 = 'C';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'X') {
                keyIDRotor3 = 'M';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Y') {
                keyIDRotor3 = 'Q';
                reflector(keyIDRotor3);
            }
            else if (keyIDRotor2 == 'Z') {
                keyIDRotor3 = 'E';
                reflector(keyIDRotor3);
            }

        }

    }



    //
    //
    //
    // Reflector
    function reflector() {

        if (keyIDRotor3 == 'A') {
            reflectorReturn = 'R';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'B') {
            reflectorReturn = 'U';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'C') {
            reflectorReturn = 'J';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'D') {
            reflectorReturn = 'Z';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'E') {
            reflectorReturn = 'X';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'F') {
            reflectorReturn = 'H';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'G') {
            reflectorReturn = 'O';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'H') {
            reflectorReturn = 'F';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'I') {
            reflectorReturn = 'L';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'J') {
            reflectorReturn = 'C';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'K') {
            reflectorReturn = 'M';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'L') {
            reflectorReturn = 'I';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'M') {
            reflectorReturn = 'K';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'N') {
            reflectorReturn = 'V';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'O') {
            reflectorReturn = 'G';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'P') {
            reflectorReturn = 'Y';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'Q') {
            reflectorReturn = 'W';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'R') {
            reflectorReturn = 'A';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'S') {
            reflectorReturn = 'T';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'T') {
            reflectorReturn = 'S';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'U') {
            reflectorReturn = 'B';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'V') {
            reflectorReturn = 'N';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'W') {
            reflectorReturn = 'Q';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'X') {
            reflectorReturn = 'E';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'Y') {
            reflectorReturn = 'P';
            returnReflector(reflectorReturn);
        }
        else if (keyIDRotor3 == 'Z') {
            reflectorReturn = 'D';
            returnReflector(reflectorReturn);
        }
    }

//
//
//
//
//
//
//
//
//
// Rotor 3 return

function returnReflector() {
    // 5
if (rotor3Input == 5) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 6
else if (rotor3Input == 6) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 13
else if (rotor3Input == 13) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 4
else if (rotor3Input == 4) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 1
else if (rotor3Input == 1) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 2
else if (rotor3Input == 2) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 20
else if (rotor3Input == 20) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 8
else if (rotor3Input == 8) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 9
else if (rotor3Input == 9) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 26
else if (rotor3Input == 26) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 11
else if (rotor3Input == 11) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 12
else if (rotor3Input == 12) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 3
else if (rotor3Input == 3) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 14
else if (rotor3Input == 14) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 15
else if (rotor3Input == 15) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 16
else if (rotor3Input == 16) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 17
else if (rotor3Input == 17) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 18
else if (rotor3Input == 18) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 19
else if (rotor3Input == 19) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 7
else if (rotor3Input == 7) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 21
else if (rotor3Input == 21) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 22
else if (rotor3Input == 22) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 23
else if (rotor3Input == 23) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 24
else if (rotor3Input == 24) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 25
else if (rotor3Input == 25) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }

}

// 10
else if (rotor3Input == 10) {

    if (reflectorReturn == 'A') {
        returnKeyIDRotor3 = 'D';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'B') {
        returnKeyIDRotor3 = 'P';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'C') {
        returnKeyIDRotor3 = 'W';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'D') {
        returnKeyIDRotor3 = 'A';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'E') {
        returnKeyIDRotor3 = 'Z';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'F') {
        returnKeyIDRotor3 = 'L';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'G') {
        returnKeyIDRotor3 = 'K';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'H') {
        returnKeyIDRotor3 = 'S';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'I') {
        returnKeyIDRotor3 = 'J';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'J') {
        returnKeyIDRotor3 = 'I';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'K') {
        returnKeyIDRotor3 = 'G';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'L') {
        returnKeyIDRotor3 = 'F';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'M') {
        returnKeyIDRotor3 = 'X';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'N') {
        returnKeyIDRotor3 = 'T';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'O') {
        returnKeyIDRotor3 = 'R';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'P') {
        returnKeyIDRotor3 = 'B';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Q') {
        returnKeyIDRotor3 = 'Y';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'R') {
        returnKeyIDRotor3 = 'O';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'S') {
        returnKeyIDRotor3 = 'H';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'T') {
        returnKeyIDRotor3 = 'N';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'U') {
        returnKeyIDRotor3 = 'V';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'V') {
        returnKeyIDRotor3 = 'U';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'W') {
        returnKeyIDRotor3 = 'C';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'X') {
        returnKeyIDRotor3 = 'M';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Y') {
        returnKeyIDRotor3 = 'Q';
        returnRotor3(returnKeyIDRotor3);
    }
    else if (reflectorReturn == 'Z') {
        returnKeyIDRotor3 = 'E';
        returnRotor3(returnKeyIDRotor3);
    }

}
}

//
//
//
//
//
//
//
//
//
// Rotor 2 return

function returnRotor3() {
    // 4
    if (rotor2Input == 4) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 8
    else if (rotor2Input == 8) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 7
    else if (rotor2Input == 7) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 1
    else if (rotor2Input == 1) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 20
    else if (rotor2Input == 20) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 26
    else if (rotor2Input == 26) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 3
    else if (rotor2Input == 3) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 2
    else if (rotor2Input == 2) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 10
    else if (rotor2Input == 10) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 9
    else if (rotor2Input == 9) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 14
    else if (rotor2Input == 14) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 15
    else if (rotor2Input == 15) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 24
    else if (rotor2Input == 24) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 11
    else if (rotor2Input == 11) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 12
    else if (rotor2Input == 12) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 16
    else if (rotor2Input == 16) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 18
    else if (rotor2Input == 18) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 17
    else if (rotor2Input == 17) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 19
    else if (rotor2Input == 19) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 5
    else if (rotor2Input == 5) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 22
    else if (rotor2Input == 22) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 21
    else if (rotor2Input == 21) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 25
    else if (rotor2Input == 25) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 13
    else if (rotor2Input == 13) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 23
    else if (rotor2Input == 23) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }

    }

    // 6
    else if (rotor2Input == 6) {

        if (returnKeyIDRotor3 == 'A') {
            returnKeyIDRotor2 = 'D';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'B') {
            returnKeyIDRotor2 = 'P';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'C') {
            returnKeyIDRotor2 = 'W';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'D') {
            returnKeyIDRotor2 = 'A';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'E') {
            returnKeyIDRotor2 = 'Z';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'F') {
            returnKeyIDRotor2 = 'L';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'G') {
            returnKeyIDRotor2 = 'K';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'H') {
            returnKeyIDRotor2 = 'S';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'I') {
            returnKeyIDRotor2 = 'J';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'J') {
            returnKeyIDRotor2 = 'I';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'K') {
            returnKeyIDRotor2 = 'G';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'L') {
            returnKeyIDRotor2 = 'F';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'M') {
            returnKeyIDRotor2 = 'X';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'N') {
            returnKeyIDRotor2 = 'T';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'O') {
            returnKeyIDRotor2 = 'R';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'P') {
            returnKeyIDRotor2 = 'B';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Q') {
            returnKeyIDRotor2 = 'Y';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'R') {
            returnKeyIDRotor2 = 'O';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'S') {
            returnKeyIDRotor2 = 'H';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'T') {
            returnKeyIDRotor2 = 'N';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'U') {
            returnKeyIDRotor2 = 'V';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'V') {
            returnKeyIDRotor2 = 'U';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'W') {
            returnKeyIDRotor2 = 'C';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'X') {
            returnKeyIDRotor2 = 'M';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Y') {
            returnKeyIDRotor2 = 'Q';
            returnRotor2(returnKeyIDRotor2);
        }
        else if (returnKeyIDRotor3 == 'Z') {
            returnKeyIDRotor2 = 'E';
            returnRotor2(returnKeyIDRotor2);
        }
    }
}

//
//
//
//
//
//
//
//
//
// Rotor 1 return
function returnRotor2() {
    // 1
    if (rotor1Input == 1) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }

    }

    // 2
    else if (rotor1Input == 2) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }

    }

    // 3
    else if (rotor1Input == 3) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }

    }

    // 4
    else if (rotor1Input == 4) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }

    }

    // 5
    else if (rotor1Input == 5) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }

    }

    // 6
    else if (rotor1Input == 6) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }

    }

    // 7
    else if (rotor1Input == 7) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }

    }

    // 8
    else if (rotor1Input == 8) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }

    }

    // 9
    else if (rotor1Input == 9) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }

    }

    // 10
    else if (rotor1Input == 10) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }

    }

    // 11
    else if (rotor1Input == 11) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }

    }

    // 12
    else if (rotor1Input == 12) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }

    }

    // 13
    else if (rotor1Input == 13) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }

    }

    // 14
    else if (rotor1Input == 14) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }

    }

    // 15
    else if (rotor1Input == 15) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }

    }

    // 16
    else if (rotor1Input == 16) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }

    }

    // 17
    else if (rotor1Input == 17) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }

    }

    // 18
    else if (rotor1Input == 18) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }

    }

    // 19
    else if (rotor1Input == 19) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }

    }

    // 20
    else if (rotor1Input == 20) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }

    }

    // 21
    else if (rotor1Input == 21) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }

    }

    // 22
    else if (rotor1Input == 22) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }

    }

    // 23
    else if (rotor1Input == 23) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }

    }

    // 24
    else if (rotor1Input == 24) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }

    }

    // 25
    else if (rotor1Input == 25) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }

    }

    // 26
    else if (rotor1Input == 26) {

        if (returnKeyIDRotor2 == 'A') {
            returnKeyIDRotor1 = 'D';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'B') {
            returnKeyIDRotor1 = 'P';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'C') {
            returnKeyIDRotor1 = 'W';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'D') {
            returnKeyIDRotor1 = 'A';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'E') {
            returnKeyIDRotor1 = 'Z';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'F') {
            returnKeyIDRotor1 = 'L';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'G') {
            returnKeyIDRotor1 = 'K';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'H') {
            returnKeyIDRotor1 = 'S';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'I') {
            returnKeyIDRotor1 = 'J';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'J') {
            returnKeyIDRotor1 = 'I';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'K') {
            returnKeyIDRotor1 = 'G';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'L') {
            returnKeyIDRotor1 = 'F';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'M') {
            returnKeyIDRotor1 = 'X';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'N') {
            returnKeyIDRotor1 = 'T';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'O') {
            returnKeyIDRotor1 = 'R';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'P') {
            returnKeyIDRotor1 = 'B';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Q') {
            returnKeyIDRotor1 = 'Y';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'R') {
            returnKeyIDRotor1 = 'O';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'S') {
            returnKeyIDRotor1 = 'H';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'T') {
            returnKeyIDRotor1 = 'N';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'U') {
            returnKeyIDRotor1 = 'V';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'V') {
            returnKeyIDRotor1 = 'U';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'W') {
            returnKeyIDRotor1 = 'C';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'X') {
            returnKeyIDRotor1 = 'M';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Y') {
            returnKeyIDRotor1 = 'Q';
            results(returnKeyIDRotor1);
        }
        else if (returnKeyIDRotor2 == 'Z') {
            returnKeyIDRotor1 = 'E';
            results(returnKeyIDRotor1);
        }

    }
}

// Plugboard Output


function results(returnKeyIDRotor1) {
    var outputResults = '';

    plugboard.forEach(pb => {
        var pbName = pb.name.replace('checkbox-key-', '');
        var pbValue = pb.value.replace('checkbox-key-', '');

        if (pbName == returnKeyIDRotor1) {
            outputResults = pbValue;
        }
        else if (pbValue == returnKeyIDRotor1) {
            outputResults = pbName;
        }

    });

    if (outputResults == '') {
        outputResults = returnKeyIDRotor1
        outputRe(outputResults);
    } else {
        outputRe(outputResults);
    }
}



    function outputRe(outputResults) {
        led.forEach(ld => {
            var ledID = ld.childNodes[0].innerHTML;

            if (ledID == outputResults) {
                output.value += ledID;
                ld.classList.add('active');
                key.classList.add('inactive');

                $('.btn-plus-1').click();

                if (rotor1Input == ring1Input) {
                    $('.btn-plus-2').click();
                }

                else if (rotor2Input == ring2Input) {
                    $('.btn-plus-3').click();
                }

                else if (rotor3Input == ring3Input) {
                    $('.btn-plus-3').click();
                }

                setTimeout(() => {
                    ld.classList.remove('active');
                    key.classList.remove('inactive');
                }, 500);
            }
        });
    }
}

    // Reset
    window.reset = function () {
        var output = document.querySelector('#output');
        var rotor1 = document.querySelector('#rotor-1');
        var rotor2 = document.querySelector('#rotor-2');
        var rotor3 = document.querySelector('#rotor-3');
        output.value = '';
        rotor1.value = 1;
        rotor2.value = 1;
        rotor3.value = 1;
    }

    // Plugboard

    // Unplug Cable
    window.undoPair = function () {

        var clickCounter = document.getElementById('counter').value;

        if ((clickCounter == 1 || clickCounter == 3 || clickCounter == 5 || clickCounter == 7 || clickCounter == 9 ||
                clickCounter == 11 || clickCounter == 13 || clickCounter == 15 || clickCounter == 17 || clickCounter ==
                19)) {

            var clickCounter2 = document.getElementById('counter').value - 1;
            var clickedEle = document.getElementById('pair_' + clickCounter2);
            var theEle = document.getElementById(clickedEle.value);
            document.querySelector('.' + theEle.id).classList.remove('inactive');
            theEle.classList.remove('pair' + clickCounter2);
            theEle.checked = false;
            clickedEle.value = "";
            document.getElementById('counter').value = clickCounter - 1;

            if (clickCounter == 1) {
                document.getElementById('undoPair').classList.add('disabled');
            }

        } else {

            var clickCounter3 = document.getElementById('counter').value - 2;
            var clickedEle = document.getElementById('pair_' + clickCounter3);
            var theEle = document.getElementById(clickedEle.name);
            document.querySelector('.' + theEle.id).classList.remove('inactive');
            theEle.classList.remove('pair' + clickCounter3);
            theEle.checked = false;
            clickedEle.name = "";
            document.getElementById('counter').value = clickCounter - 1;

            if (clickCounter == 20) {
                document.querySelector('.plugboard').classList.remove('inactive');
            }
        }

    }

    // Make Pairs
    window.plugboard = function (clicked_id) {
        var checkedKeyID = clicked_id.replace('checkbox-key-', '');
        var clickCounter = document.getElementById('counter').value;

        // Pair 1
        if (clickCounter == 0) {
            document.getElementById('pair_0').value = clicked_id;
            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair0');
            document.getElementById('counter').value = "1";
            document.getElementById('undoPair').classList.remove('disabled');
        }

        else if (clickCounter == 1) {
            var secondEle = document.getElementById('pair_0').name = clicked_id;
            var firstEle = document.getElementById('pair_0').value;

            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair0');
            document.getElementById('counter').value = "2";

        }

        // Pair 2
        else if (clickCounter == 2) {
            document.getElementById('pair_2').value = clicked_id;
            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair2');
            document.getElementById('counter').value = "3";
        }

        else if (clickCounter == 3) {
            var secondEle = document.getElementById('pair_2').name = clicked_id;
            var firstEle = document.getElementById('pair_2').value;

            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair2');
            document.getElementById('counter').value = "4";

        }

        // Pair 3
        else if (clickCounter == 4) {
            document.getElementById('pair_4').value = clicked_id;
            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair4');
            document.getElementById('counter').value = "5";
        }

        else if (clickCounter == 5) {
            var secondEle = document.getElementById('pair_4').name = clicked_id;
            var firstEle = document.getElementById('pair_4').value;

            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair4');
            document.getElementById('counter').value = "6";

        }

        // Pair 4
        else if (clickCounter == 6) {
            document.getElementById('pair_6').value = clicked_id;
            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair6');
            document.getElementById('counter').value = "7";
        }

        else if (clickCounter == 7) {
            var secondEle = document.getElementById('pair_6').name = clicked_id;
            var firstEle = document.getElementById('pair_6').value;

            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair6');
            document.getElementById('counter').value = "8";

        }

        // Pair 5
        else if (clickCounter == 8) {
            document.getElementById('pair_8').value = clicked_id;
            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair8');
            document.getElementById('counter').value = "9";
        }

        else if (clickCounter == 9) {
            var secondEle = document.getElementById('pair_8').name = clicked_id;
            var firstEle = document.getElementById('pair_8').value;

            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair8');
            document.getElementById('counter').value = "10";

        }

        // Pair 6
        else if (clickCounter == 10) {
            document.getElementById('pair_10').value = clicked_id;
            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair10');
            document.getElementById('counter').value = "11";
        }

        else if (clickCounter == 11) {
            var secondEle = document.getElementById('pair_10').name = clicked_id;
            var firstEle = document.getElementById('pair_10').value;

            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair10');
            document.getElementById('counter').value = "12";

        }

        // Pair 7
        else if (clickCounter == 12) {
            document.getElementById('pair_12').value = clicked_id;
            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair12');
            document.getElementById('counter').value = "13";
        }

        else if (clickCounter == 13) {
            var secondEle = document.getElementById('pair_12').name = clicked_id;
            var firstEle = document.getElementById('pair_12').value;

            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair12');
            document.getElementById('counter').value = "14";

        }

        // Pair 8
        else if (clickCounter == 14) {
            document.getElementById('pair_14').value = clicked_id;
            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair14');
            document.getElementById('counter').value = "15";
        }

        else if (clickCounter == 15) {
            var secondEle = document.getElementById('pair_14').name = clicked_id;
            var firstEle = document.getElementById('pair_14').value;

            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair14');
            document.getElementById('counter').value = "16";

        }

        // Pair 9
        else if (clickCounter == 16) {
            document.getElementById('pair_16').value = clicked_id;
            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair16');
            document.getElementById('counter').value = "17";
        }

        else if (clickCounter == 17) {
            var secondEle = document.getElementById('pair_16').name = clicked_id;
            var firstEle = document.getElementById('pair_16').value;

            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair16');
            document.getElementById('counter').value = "18";

        }

        // Pair 10
        else if (clickCounter == 18) {
            document.getElementById('pair_18').value = clicked_id;
            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair18');
            document.getElementById('counter').value = "19";
        }

        else if (clickCounter == 19) {
            var secondEle = document.getElementById('pair_18').name = clicked_id;
            var firstEle = document.getElementById('pair_18').value;

            document.querySelector('.' + clicked_id).classList.add('inactive');
            document.getElementById(clicked_id).classList.add('pair18');
            document.getElementById('counter').value = "20";

            document.querySelector('.plugboard').classList.add('inactive');

        }
    }


    // Number Inputs repeat

    $(function() {
        $("input").change(function() {
            var max = parseInt($(this).attr('max'));
            var min = parseInt($(this).attr('min'));
            if ($(this).val() > max) {
                $(this).val(min);
            } else if ($(this).val() < min) {
                $(this).val(min);
            }
        });
    });


    // rotors


    // rotor 1 numbers steps

    $('.btn-plus-1, .btn-minus-1').on('click', function(e) {
        const isNegative = $(e.target).closest('.btn-minus-1').is('.btn-minus-1');
        const input = $(e.target).closest('.rotor-1').find('input');
        if (input.is('input')) {
            input[0][isNegative ? 'stepDown' : 'stepUp']();

            var rotorInput = document.querySelector('#rotor-1');

            if (rotorInput.value > 26) {
                rotorInput.value = 1
            } else if (rotorInput.value < 1) {
                rotorInput.value = 26
            }
        }
    })

    // rotor 2 numbers steps
    $('.btn-plus-2, .btn-minus-2').on('click', function(e) {
        const isNegative = $(e.target).closest('.btn-minus-2').is('.btn-minus-2');
        const input = $(e.target).closest('.rotor-2').find('input');
        if (input.is('input')) {
            input[0][isNegative ? 'stepDown' : 'stepUp']();

            var rotorInput = document.querySelector('#rotor-2');

            if (rotorInput.value > 26) {
                rotorInput.value = 1
            } else if (rotorInput.value < 1) {
                rotorInput.value = 26
            }
        }
    })

    // rotor 3 numbers steps
    $('.btn-plus-3, .btn-minus-3').on('click', function(e) {
        const isNegative = $(e.target).closest('.btn-minus-3').is('.btn-minus-3');
        const input = $(e.target).closest('.rotor-3').find('input');
        if (input.is('input')) {
            input[0][isNegative ? 'stepDown' : 'stepUp']();

            var rotorInput = document.querySelector('#rotor-3');

            if (rotorInput.value > 26) {
                rotorInput.value = 1
            } else if (rotorInput.value < 1) {
                rotorInput.value = 26
            }
        }
    })


    // Rings

    // Ring 1 numbers steps
    $('.btn-plus-ring-1, .btn-minus-ring-1').on('click', function(e) {
        const isNegative = $(e.target).closest('.btn-minus-ring-1').is('.btn-minus-ring-1');
        const input = $(e.target).closest('.ring-1').find('input');
        if (input.is('input')) {
            input[0][isNegative ? 'stepDown' : 'stepUp']();

            var rotorInput = document.querySelector('#ring-1');

            if (rotorInput.value > 26) {
                rotorInput.value = 1
            } else if (rotorInput.value < 1) {
                rotorInput.value = 26
            }
        }
    })

    // Ring 2 numbers steps
    $('.btn-plus-ring-2, .btn-minus-ring-2').on('click', function(e) {
        const isNegative = $(e.target).closest('.btn-minus-ring-2').is('.btn-minus-ring-2');
        const input = $(e.target).closest('.ring-2').find('input');
        if (input.is('input')) {
            input[0][isNegative ? 'stepDown' : 'stepUp']();

            var rotorInput = document.querySelector('#ring-2');

            if (rotorInput.value > 26) {
                rotorInput.value = 1
            } else if (rotorInput.value < 1) {
                rotorInput.value = 26
            }
        }
    })

    // Ring 3 numbers steps
    $('.btn-plus-ring-3, .btn-minus-ring-3').on('click', function(e) {
        const isNegative = $(e.target).closest('.btn-minus-ring-3').is('.btn-minus-ring-3');
        const input = $(e.target).closest('.ring-3').find('input');
        if (input.is('input')) {
            input[0][isNegative ? 'stepDown' : 'stepUp']();

            var rotorInput = document.querySelector('#ring-3');

            if (rotorInput.value > 26) {
                rotorInput.value = 1
            } else if (rotorInput.value < 1) {
                rotorInput.value = 26
            }
        }
    })
